import MaintenanceState from '@rio-cloud/rio-uikit/MaintenanceState';
import type { FunctionComponent } from 'react';

const UnderConstruction: FunctionComponent = () => (
    <MaintenanceState headline='Under Construction' message='Hier wird noch gearbeitet.' />
);
export default UnderConstruction;
